<template>
    <data-form title="Add Subcontractors to Project"
               class="layout-small-form"
               save-button-label="Add Subs"
               :field-model="projectFields"
               :field-groups="fieldGroups"
               :on-submit-handler="onSubmit"
               :cancelRoute="returnRoute"
               submit-success-message="Sub Added"
               submit-error-message="Error Adding Sub to Project"
               :submit-success-route="returnRoute"/>
</template>

<script>

import ProjectFields from '@/models/Project'

export default {
    name: 'ProjectAddSub',
    props: {
        projectId: Number,
    },
    data () {
        return {
            projectFields: ProjectFields,
            fieldGroups: [['subCompanies']]
        }
    },
    computed: {
        returnRoute () {
            return '/project/view/' + this.projectId
        }
    },
    methods: {
        onSubmit (modelInstance) {
            modelInstance.id = this.projectId
            this.$api.addSubcontractors(this, modelInstance)
        }
    }
}
</script>

<style scoped>

</style>